import { NavLink, Outlet } from 'react-router-dom'
import { LayoutDashboard, FileText, Receipt, User, ShoppingBag, Heart } from 'lucide-react'
import { usePortalStore } from '@/stores/portal.store'

const tabs = [
    { to: '/portal', icon: LayoutDashboard, label: 'Início', end: true },
    { to: '/portal/loja', icon: ShoppingBag, label: 'Loja', end: false },
    { to: '/portal/pontos', icon: Heart, label: 'Pontos', end: false },
    { to: '/portal/contratos', icon: FileText, label: 'Contratos', end: false },
    { to: '/portal/faturas', icon: Receipt, label: 'Faturas', end: false },
]

export function PortalLayout() {
    const { associado, logout } = usePortalStore()

    return (
        <div className="min-h-screen bg-[#F8FAFC] flex flex-col font-['Poppins',sans-serif]">
            {/* Poppins CSS */}
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
                body { font-family: 'Poppins', sans-serif; }
            `}</style>

            {/* Header */}
            <header className="bg-[#003E8A] border-b border-[#002B61] px-5 py-4 flex items-center justify-between sticky top-0 z-30 shadow-lg">
                <div className="flex items-center gap-3">
                    <img 
                        src="/logobranca.png" 
                        alt="Multiveicular" 
                        className="h-6 w-auto object-contain"
                    />
                </div>
                
                <NavLink 
                  to="/portal/perfil"
                  className={({ isActive }) => `
                    w-9 h-9 rounded-full transition-all flex items-center justify-center text-white
                    ${isActive ? 'bg-white text-[#003E8A]' : 'bg-white/10 hover:bg-white/20'}
                  `}
                >
                    <User size={18} />
                </NavLink>
            </header>

            {/* Content area */}
            <main className="flex-1 pb-24">
                <Outlet />
            </main>

            {/* Bottom tab bar */}
            <nav className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100 safe-area-bottom shadow-[0_-10px_30px_rgba(0,62,138,0.08)] rounded-t-[1.5rem]">
                <div className="flex items-stretch max-w-lg mx-auto h-20">
                    {tabs.map(({ to, icon: Icon, label, end }) => (
                        <NavLink
                            key={to}
                            to={to}
                            end={end}
                            className={({ isActive }) =>
                                `flex-1 flex flex-col items-center justify-center gap-1 transition-all
                                ${isActive ? 'text-[#003E8A]' : 'text-gray-300 hover:text-gray-400'}`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <div className={`
                                        transition-all duration-300 p-1.5 rounded-xl
                                        ${isActive ? 'bg-[#003E8A]/5 scale-110' : ''}
                                    `}>
                                        <Icon size={24} strokeWidth={isActive ? 2.5 : 2} />
                                    </div>
                                    <span className="text-[10px] font-bold uppercase tracking-wider">{label}</span>
                                </>
                            )}
                        </NavLink>
                    ))}
                </div>
            </nav>
        </div>
    )
}
